import { createCancelAccountToken } from '../services/accountService'

function fetchCancelAccountTokenCreate() {
  return () => createCancelAccountToken()
}

export default fetchCancelAccountTokenCreate
